import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    inject,
    signal,
    Signal,
    WritableSignal,
    computed,
    input,
    InputSignal,
    OnDestroy,
    effect,
    untracked,
} from '@angular/core';
import {
    IqEventBusBrokerService,
    IqEventBusBrokerHandler,
} from '@dat/iq-event-bus';

import { EquipmentTypes, EquipmentTypePayloadSchema, MatrixRequest, MatrixRequestSchema } from '../models';
import { IqStateRegionMatrixStateService } from '../state';
import { isNil } from 'lodash';

@Component({
    selector: 'iq-state-region-matrix-card',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './iq-state-region-matrix-card.component.html',
    styleUrl: './iq-state-region-matrix-card.component.scss',
})
export class IqStateRegionMatrixCardComponent implements OnDestroy {
    id: InputSignal<string> = input<string>('');
    equipmentType: WritableSignal<EquipmentTypes> = signal(EquipmentTypes.Van);
    fuelSurcharge: Signal<number> = computed(() => {
        if (isNil(this._state.fuelSurcharge())) { return null; }
        
        return this._state.fuelSurcharge();
    });

    private _eventBus: IqEventBusBrokerService = inject(IqEventBusBrokerService);
    private _dispatchedActions: Record<string, IqEventBusBrokerHandler> = {};
    private _state: IqStateRegionMatrixStateService = inject(IqStateRegionMatrixStateService);

    constructor() {
        //#region Register Event Listeners
        this._dispatchedActions = this._eventBus.registerMap({
            'setLandingEquipmentType': {
                callback: (payload: any) => {
                    const test = EquipmentTypePayloadSchema.safeParse(payload);                    
                    if (!test.success) {
                        console.warn(
                            'setLandingEquipmentType Invalid Payload',
                        );
                        return;
                    }

                    this.equipmentType.set(payload.equipmentType);
                },
                opts: {
                    immediate: false
                }
            },
        });
        //#endregion

        effect(() => {
            const fuelSurcharge = this.fuelSurcharge();

            untracked(() => {
                this._eventBus.dispatch({
                    name: 'setStateMatrixFuelSurcharge',
                    payload: {
                        label: this.fuelSurcharge() ? fuelSurcharge : 0.00,
                    },
                });
            });
        });
    }

    //#region Handle Download (Dispatch Click Event and Fetch File Event)
    clickedDownloadLink(geoType: string, rateType: string) {
        const matrixRequest: MatrixRequest = {
            equipmentType: this.equipmentType(),
            geoType: geoType,
            rateType: rateType,
        }

        const dispatch = () => {
            this._eventBus.dispatch({
                name: 'type:click',
                payload: {
                    id: this.id,
                    matrixRequest,
                },
            });
            this._eventBus.dispatch({
                name: 'type:fetch-matrix-file',
                payload: {
                    id: this.id,
                    matrixRequest,
                },
            });
        };

        dispatch();        
    }
    //#endregion


    ngOnDestroy(): void {
        this._eventBus.unregisterMap(this._dispatchedActions);
    }
    
}
